import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  stepFourListName: {
    id: 'EDITUSERIMPORT.STEP4.LISTNAME',
    defaultMessage: 'Import List Name'
  }
});
